export default __webpack_public_path__ + "static/media/bridgegap.84a6d776.jpg";